import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistStorageSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  storageToxic: environmentalChecklistItem,
  storageClean: environmentalChecklistItemWithTicket,
  storageSupplies: environmentalChecklistItem,
  storageClearance: environmentalChecklistItem,
  storagePpe: environmentalChecklistItem,
  storageComment: z.string().optional(),
});
